msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-08-14 12:05+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: fr\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: Poedit 3.7\n"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:11
msgid "safeSend.tabs.header.dbName"
msgstr "Nom"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:16
msgid "safeSend.tabs.header.emails"
msgstr "Adresses email exclues"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:23
msgid "safeSend.tabs.header.actions"
msgstr "Actions suspectes"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:30
msgid "safeSend.tabs.header.status"
msgstr "Statut"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/NewFeatureBanner/index.tsx:8
msgid "features.newFeatureBanner.safesend"
msgstr "<bold>⭐️ Nouveauté :</bold> SafeSend, le filtre pour adresses email dangereuses"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:73
msgid "features.footer.followEmailTrainingLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/formations-email-delivrabilite-deduplication-et-reactivation-des-inactifs/"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:85
msgid "features.footer.learnMoreLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/audits-conseils-gestion-emailing/"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:36
msgid "dashboards.menuCards.deliverability.content"
msgstr "Vue globale de votre délivrabilité sur toutes les bases"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:38
msgid "dashboards.menuCards.deliverability.title"
msgstr "Rapport de délivrabilité"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:43
msgid "dashboards.menuCards.campaign.content"
msgstr "Analysez les performances des campagnes et segments sur chaque base"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:45
msgid "dashboards.menuCards.campaign.title"
msgstr "Statistiques de campagne"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:59
msgid "dashboards.title"
msgstr "Bienvenue dans Mindbaz Dashboards !"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:60
msgid "dashboards.description"
msgstr "Suivez la délivrabilité et les performances des campagnes sur vos bases Mindbaz. Avec notre tableau de bord \"Rapport de délivrabilité\", vous pouvez surveiller la délivrabilité et la réputation de vos domaines et adresses IP auprès des FAI. Analysez les performances des campagnes dans leur ensemble ou par segment avec notre tableau de bord \"Statistiques de campagne\"."

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:75
msgid "dashboards.customDashboards"
msgstr "Tableaux de bord personnalisés"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:105
msgid "dashboards.needCustomDashboard"
msgstr "Besoin d'un tableau de bord personnalisé ?"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:99
msgid "snapshot.gridPerformances.header.sentRate"
msgstr "Taux d'envoi"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:106
msgid "snapshot.gridPerformances.header.deliveredEmails"
msgstr "Emails délivrés"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:113
msgid "snapshot.gridPerformances.header.hardBounce"
msgstr "Hard bounces"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:121
msgid "snapshot.gridPerformances.header.openers"
msgstr "Ouvreurs"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:128
msgid "snapshot.gridPerformances.header.clickers"
msgstr "Cliqueurs"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:135
msgid "snapshot.gridPerformances.header.unsubscribes"
msgstr "Désabonnements"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:145
msgid "table.labelRowsPerPage"
msgstr "Résultats par page :"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:147
msgid "table.labelDisplayedRowsSeparator"
msgstr "sur"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:150
msgid "table.labelNoRows"
msgstr "Désolé, aucun résultat ne correspond à votre recherche"

#. js-lingui-explicit-id
#: src/pages/DailyReport/TabInformations/index.tsx:46
msgid "snapshot.databases"
msgstr "Base de données"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:130
msgid "safesend.dailyStats.excludedEmails"
msgstr "Adresses email exclues"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:134
msgid "safesend.dailyStats.suspiciousActions"
msgstr "Actions suspectes"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:156
#: src/pages/SafeSend/index.tsx:174
msgid "safesend.databaseStats.fromDate"
msgstr "Activé depuis le {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:165
msgid "safesend.databaseStats.untilDate"
msgstr "Activé jusqu'au {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:186
msgid "safesend.databaseStats.dateRange"
msgstr "Du {startDate} au {endDate}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:194
msgid "safesend.cards.emails.title"
msgstr "Adresses email exclues"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:195
msgid "safesend.cards.emails.description"
msgstr "{data} adresses email ont été exclues de vos envois."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:204
msgid "safesend.cards.actions.title"
msgstr "Actions suspectes"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:205
msgid "safesend.cards.actions.description"
msgstr "Les actions de {data} adresses email suspectes ont été limitées dans vos statistiques."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:235
msgid "table.search"
msgstr "Rechercher"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:236
msgid "table.elementsTabCount"
msgstr "éléments sur ma page"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:245
msgid "safesend.title"
msgstr "SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:246
msgid "safesend.description"
msgstr "Suivez le nombre d'adresses email exclues de vos envois et dont les actions sont limitées dans vos statistiques grâce à SafeSend. Pour en savoir plus sur SafeSend, "

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:248
msgid "safesend.descriptionLink"
msgstr "https://serviceclient.mindbaz.com/fr/faq/safesend-le-filtre-%C3%A0-emails-dangereux.-par-mindbaz"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:257
msgid "safesend.panel.title"
msgstr "Choix de la période"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:258
msgid "safesend.panel.period"
msgstr "Période"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:341
msgid "safesend.popup.title"
msgstr "Choix de la période"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:346
msgid "safesend.popup.description"
msgstr "Pour modifier l'offre SafeSend, veuillez contacter un administrateur : {adminList}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:107
msgid "snapshot.tabs.general.title"
msgstr "Général"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:120
msgid "snapshot.tabs.performance.title"
msgstr "Performance par base"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:152
msgid "snapshot.title"
msgstr "Bienvenue dans votre aperçu de délivrabilité !"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:153
msgid "snapshot.description"
msgstr "Consultez vos statistiques email pour <strong>{values}</strong>. Dans l'<strong>onglet Général</strong>, vous trouverez les alertes de délivrabilité qui étaient actives à cette date et les performances de vos bases. Si vous souhaitez une vue détaillée par base, utilisez l'<strong>onglet Performance par base</strong>."

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:158
msgid "snapshot.displayStatistics"
msgstr "Afficher les statistiques le"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:172
msgid "snapshot.switch_apple_mpp.label"
msgstr "Inclure"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:176
msgid "snapshot.switch_apple_mpp.link"
msgstr "https://serviceclient.mindbaz.com/fr/faq/apple-mail-privacy-protection-mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:178
msgid "snapshot.switch_apple_mpp.linkText"
msgstr "Apple MPP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:180
msgid "snapshot.switch_apple_mpp.endLabel"
msgstr "ouvertures"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:5
msgid "features.cards.safesend.title"
msgstr "Filtrer automatiquement les emails dangereux"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:6
msgid "features.cards.safesend.description"
msgstr "SafeSend est le filtre Mindbaz qui supprime automatiquement les adresses email dangereuses de vos envois."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:7
msgid "features.cards.safesend.bafflingProblem"
msgstr "Vos campagnes email sont impactées par les bots, plaintes spam, pièges à spam et emails jetables, qui réduisent votre taux de délivrabilité et votre réputation auprès des FAI."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:8
msgid "features.cards.safesend.goal"
msgstr "Envoyez vos campagnes uniquement aux bonnes adresses et optimisez votre délivrabilité sans effort."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:9
msgid "features.cards.safesend.activateFeature"
msgstr "Activer SafeSend"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:12
msgid "features.cards.dashboards.title"
msgstr "Visualisez les performances de toutes vos bases avec une vue globale"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:13
msgid "features.cards.dashboards.description"
msgstr "Avec Dashboards, vous n'avez plus besoin de quitter votre routeur email pour analyser toutes vos campagnes."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:14
msgid "features.cards.dashboards.bafflingProblem"
msgstr "Pour envoyer des campagnes email en masse, la plupart de nos clients utilisent différentes bases de données. Quand la même campagne email est envoyée à plusieurs bases, comment estimez-vous la performance globale de la campagne sur les fournisseurs de messagerie ?"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:15
msgid "features.cards.dashboards.goal"
msgstr "Utilisez un outil de visualisation de données multi-bases."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:16
msgid "features.cards.dashboards.activateFeature"
msgstr "Essai gratuit 30 jours"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:19
msgid "features.cards.snapshot.title"
msgstr "Obtenez un aperçu quotidien de votre délivrabilité"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:20
msgid "features.cards.snapshot.description"
msgstr "Snapshot vous permet d'anticiper les problèmes de délivrabilité pour les résoudre rapidement."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:21
msgid "features.cards.snapshot.bafflingProblem"
msgstr "Les agences qui envoient des campagnes email en masse peuvent être sujettes aux risques de délivrabilité et aux changements des bonnes pratiques. Si vous vérifiez chaque campagne individuellement pour essayer de comprendre la raison d'une baisse de délivrabilité, c'est une perte de temps."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:22
msgid "features.cards.snapshot.goal"
msgstr "Gagnez du temps sur l'analyse de votre délivrabilité auprès des fournisseurs de messagerie en profitant d'un aperçu quotidien de votre délivrabilité."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:23
msgid "features.cards.snapshot.activateFeature"
msgstr "Essai gratuit 30 jours"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:28
msgid "safesend.panel.thirtyLastDays"
msgstr "30 derniers jours"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:29
msgid "safesend.panel.currentMonth"
msgstr "Mois en cours"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:30
msgid "safesend.panel.lastMonth"
msgstr "Mois dernier"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:31
msgid "safesend.panel.threeLastMonths"
msgstr "3 derniers mois"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:32
msgid "safesend.panel.sixLastMonths"
msgstr "6 derniers mois"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:321
msgid "snapshot.general.preblockSummary"
msgstr "Préblocage Mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:322
#: src/pages/DailyReport/useCards.tsx:340
msgid "snapshot.general.preblock.level"
msgstr "Niv. "

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:360
msgid "snapshot.general.blacklistSummary"
msgstr "Blacklist"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:379
msgid "snapshot.general.undelegatedSummary"
msgstr "Domaine non délégué"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:447
msgid "{nbPreblock, plural, one {# Mindbaz Preblock} other {# Mindbaz Preblocks}}"
msgstr "{nbPreblock, plural, one {# Préblock Mindbaz} other {# Préblocks Mindbaz}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:457
msgid "snapshot.general.noPreblock"
msgstr "Aucun préblocage Mindbaz actuellement"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:465
msgid "{nbBlacklist, plural, one {# Blacklist} other {# Blacklists}}"
msgstr "{nbBlacklist, plural, one {# Liste noire} other {# Listes noires}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:471
msgid "snapshot.general.noBlacklist"
msgstr "Aucune blacklist"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:479
msgid "{nbUndelegated, plural, one {# Undelegated domain} other {# Undelegated domains}}"
msgstr "{nbUndelegated, plural, one {# Domaine non délégué} other {# Domaines non délégués}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:489
msgid "snapshot.general.noUndelegated"
msgstr "Tous vos domaines sont délégués"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:497
msgid "snapshot.general.performance"
msgstr "Performance par base"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:544
msgid "snapshot.performance.email"
msgstr "Emails envoyés par FAI"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:566
msgid "snapshot.performance.deliverability"
msgstr "Délivrabilité par FAI"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:585
msgid "{nbDeliverabilityAlert, plural, one {# deliverability alert} other {# deliverability alerts}}"
msgstr "{nbDeliverabilityAlert, plural, one {# alerte de délivrabilité} other {# alertes de délivrabilité}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:595
msgid "snapshot.performance.noDeliverabilityAlert"
msgstr "Aucune alerte de délivrabilité actuelle"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:603
msgid "snapshot.performance.performance"
msgstr "Performance par FAI"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:620
msgid "snapshot.performance.spamVol"
msgstr "Plaintes spam (vol.)"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:623
#: src/pages/DailyReport/useCards.tsx:651
msgid "snapshot.performance.noResult"
msgstr "Aucune plainte spam le {{date}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:648
msgid "snapshot.performance.spamPercent"
msgstr "Plaintes spam (%)"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:154
msgid "features.goal"
msgstr "🎯 Votre objectif"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:148
msgid "features.bafflingProblem"
msgstr "🤯 Le puzzle"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:249
msgid "safesend.descriptionClickHere"
msgstr "cliquez ici."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:325
msgid "safesend.databaseDetails"
msgstr "Détails par base"

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:159
msgid "features.description"
msgstr "Découvrez les fonctionnalités de Rubixo qui s'appuient sur l'analyse de 16 milliards d'emails routés par Mindbaz chaque année."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:88
msgid "feature.footer.learnMore"
msgstr "En savoir plus sur les audits email de Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:131
msgid "features.learnMore"
msgstr "En savoir plus"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:45
msgid "gone_page.link"
msgstr "En savoir plus sur Dashboards"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:31
msgid "page_not_found.button"
msgstr "Se connecter à Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:112
msgid "features.manageOffer"
msgstr "Gérer mon abonnement"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:337
msgid "safesend.updateOffer"
msgstr "Modifier mon offre SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:351
msgid "safesend.popup.confirm"
msgstr "Modifier mon offre SafeSend"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:34
msgid "feature.footer.featureInProgress"
msgstr "D'autres fonctionnalités arrivent."

#. js-lingui-explicit-id
#: src/pages/Common/AccessDenied.tsx:38
msgid "oops"
msgstr "Oups ! Vous n'avez pas accès à cette plateforme."

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:31
msgid "gone_page.description1"
msgstr "Les rapports Snapshot sont accessibles <strong>7 jours</strong> après leur publication."

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:151
msgid "features.title"
msgstr "Résolvez le puzzle de la délivrabilité email avec Rubixo"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:40
msgid "feature.footer.follow"
msgstr "Restez à l'écoute pour ne rien manquer !"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:76
msgid "feature.footer.followEmailTraining"
msgstr "Suivez une formation email avec Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:20
msgid "page_not_found.title"
msgstr "Cette page n'existe pas"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:25
msgid "gone_page.title"
msgstr "Ce rapport Snapshot n'est plus disponible"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:37
msgid "gone_page.description2"
msgstr "Pour avoir une vue complète de vos envois, nous vous invitons à découvrir Dashboards."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:66
msgid "feature.footer.optimizeEmail"
msgstr "Envie d'optimiser votre marketing par email ?"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:24
msgid "page_not_found.description"
msgstr "Nous n'avons pas trouvé la page que vous cherchiez"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:105
msgid "features.freeAccess"
msgstr "Vous avez actuellement un accès gratuit"
